import { ServiceTicket, Service, ServiceTicket_$reflection, MachineInfo_$reflection, Machine_$reflection, CustomerInfo_$reflection, Service_$reflection, Machine as Machine_1 } from "./Shared/ApiDataTypes.js";
import { Union, Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { Table, Target__ToMachines, Target__ToMachineOpt, Target__ToCustomersOpt, CreationDialog, Target__RequestPath, Target, Target_$reflection } from "./Activities/Services.js";
import { obj_type, union_type, record_type, string_type, bool_type, option_type, array_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { FetchError, FetchError_$reflection } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { singleton as singleton_1, getSubArray, sortBy, pick, map, append } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { unwrap, map as map_1, defaultArg, some } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { API_Machine_Services } from "./Shared/Urls.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Customer_fetchCustomerInfo, Machine_fetchMachineInfo, testRedirect, extraCoders, corsProps } from "./Promises.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { comparePrimitives, createObj, uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "./Context.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Pagination, Typography } from "@mui/material";
import { join, interpolate, toText } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { empty as empty_1, append as append_1, singleton, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { Components_ActivityItem_Z3817E89A } from "./Components/Activities/ActivityItem.js";
import { useResponsive } from "./Utils.js";
import { month, year, parse } from "./fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { toLongTimeString, month as month_1, now, year as year_1 } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { useEffectWithDeps } from "./fable_modules/Feliz.2.8.0/ReactInterop.js";
import { useEffectOnce, createDisposable } from "./fable_modules/Feliz.2.8.0/Internal.fs.js";
import { SnackError } from "./ViewHelpers.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiXHelpers_createElement } from "./fable_modules/Feliz.MuiX.DatePickers.6.9.2-alpha.6/Mui.fs.js";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Components_ActivityCalendar_Z2E686B84 } from "./Components/Activities/ActivityCalendar.js";

export function infoToMachine(machine) {
    return new Machine_1(machine.Id, machine.Code, machine.Name, machine.SerialNumber, "", false, machine.SubGroup, machine.WarrantyExpiry, undefined);
}

class Model extends Record {
    constructor(Target, Entries, Customers, Customer, Machine, AddForm, EditForm, ErrorMsg) {
        super();
        this.Target = Target;
        this.Entries = Entries;
        this.Customers = Customers;
        this.Customer = Customer;
        this.Machine = Machine;
        this.AddForm = AddForm;
        this.EditForm = EditForm;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Kundeweb.ActivityView.Model", [], Model, () => [["Target", Target_$reflection()], ["Entries", array_type(Service_$reflection())], ["Customers", option_type(array_type(CustomerInfo_$reflection()))], ["Customer", option_type(CustomerInfo_$reflection())], ["Machine", option_type(Machine_$reflection())], ["AddForm", bool_type], ["EditForm", option_type(Service_$reflection())], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CreateResponse", "CustomerResponse", "CustomersResponse", "DeleteEntry", "EntriesResponse", "MachineResponse", "SetEntries", "ToggleAddForm", "UpdateEntry", "UpdateResponse", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Kundeweb.ActivityView.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Service_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Service_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [CustomerInfo_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", CustomerInfo_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(CustomerInfo_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(CustomerInfo_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", Service_$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Service_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Service_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [MachineInfo_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", MachineInfo_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", array_type(Service_$reflection())]], [["Item", bool_type]], [["Item", Service_$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Service_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", Service_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], []]);
}

function init(target) {
    return new Model(target, [], undefined, undefined, undefined, false, undefined, undefined);
}

function update(model, msg) {
    let matchValue, matchValue_1, matchValue_2;
    switch (msg.tag) {
        case 2: {
            const res_1 = msg.fields[0];
            if (res_1.tag === 0) {
                const x_1 = res_1.fields[0];
                return new Model((matchValue = model.Target, (matchValue.tag === 0) ? (new Target(0, [matchValue.fields[0], x_1])) : model.Target), model.Entries, x_1, model.Customer, model.Machine, model.AddForm, model.EditForm, model.ErrorMsg);
            }
            else {
                return new Model(model.Target, model.Entries, model.Customers, model.Customer, model.Machine, model.AddForm, model.EditForm, "Kunne ikke laste kunder");
            }
        }
        case 1: {
            const res_2 = msg.fields[0];
            if (res_2.tag === 0) {
                const x_2 = res_2.fields[0];
                return new Model((matchValue_1 = model.Target, (matchValue_1.tag === 1) ? (new Target(1, [matchValue_1.fields[0], matchValue_1.fields[1], x_2])) : model.Target), model.Entries, model.Customers, x_2, model.Machine, model.AddForm, model.EditForm, model.ErrorMsg);
            }
            else {
                return new Model(model.Target, model.Entries, model.Customers, model.Customer, model.Machine, model.AddForm, model.EditForm, "Kunne ikke laste kundeinfo");
            }
        }
        case 5: {
            const res_3 = msg.fields[0];
            if (res_3.tag === 0) {
                const x_3 = res_3.fields[0];
                const updatedMachine = infoToMachine(x_3);
                return new Model((matchValue_2 = model.Target, (matchValue_2.tag === 2) ? (new Target(2, [matchValue_2.fields[0], matchValue_2.fields[1], matchValue_2.fields[2], infoToMachine(x_3)])) : model.Target), model.Entries, model.Customers, model.Customer, updatedMachine, model.AddForm, model.EditForm, model.ErrorMsg);
            }
            else {
                return new Model(model.Target, model.Entries, model.Customers, model.Customer, model.Machine, model.AddForm, model.EditForm, "Kunne ikke laste anleggsinfo");
            }
        }
        case 3:
            return new Model(model.Target, model.Entries.filter((activity) => (activity.Id !== msg.fields[0].Id)), model.Customers, model.Customer, model.Machine, model.AddForm, model.EditForm, model.ErrorMsg);
        case 6:
            return new Model(model.Target, msg.fields[0], model.Customers, model.Customer, model.Machine, model.AddForm, model.EditForm, model.ErrorMsg);
        case 7:
            return new Model(model.Target, model.Entries, model.Customers, model.Customer, model.Machine, msg.fields[0], model.EditForm, model.ErrorMsg);
        case 0: {
            const res_4 = msg.fields[0];
            if (res_4.tag === 0) {
                return new Model(model.Target, append(model.Entries, res_4.fields[0]), model.Customers, model.Customer, model.Machine, false, model.EditForm, model.ErrorMsg);
            }
            else {
                console.error(some("Could not create service:"), res_4.fields[0]);
                return new Model(model.Target, model.Entries, model.Customers, model.Customer, model.Machine, false, model.EditForm, "Create error");
            }
        }
        case 9: {
            const res_5 = msg.fields[0];
            if (res_5.tag === 0) {
                const x_5 = res_5.fields[0];
                return new Model(model.Target, map((entry) => {
                    if (x_5.Id === entry.Id) {
                        return x_5;
                    }
                    else {
                        return entry;
                    }
                }, model.Entries), model.Customers, model.Customer, model.Machine, model.AddForm, undefined, model.ErrorMsg);
            }
            else {
                return new Model(model.Target, model.Entries, model.Customers, model.Customer, model.Machine, model.AddForm, undefined, "Update error");
            }
        }
        case 8: {
            const updatedEntry = msg.fields[0];
            console.debug("[Activity view] Update entry");
            return new Model(model.Target, map((service) => {
                if (updatedEntry.Id === service.Id) {
                    return updatedEntry;
                }
                else {
                    return service;
                }
            }, model.Entries), model.Customers, model.Customer, model.Machine, model.AddForm, model.EditForm, model.ErrorMsg);
        }
        case 10:
            return new Model(model.Target, model.Entries, model.Customers, model.Customer, model.Machine, model.AddForm, model.EditForm, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 0) {
                const x = res.fields[0];
                console.debug("[ActivitiesView] Got activities", x);
                return new Model(model.Target, x, model.Customers, model.Customer, model.Machine, model.AddForm, model.EditForm, model.ErrorMsg);
            }
            else {
                return model;
            }
        }
    }
}

function tryCreate(dispatch, newService) {
    console.debug("ServiceView trycreate:", newService);
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let body, decoder, data_1, caseStrategy_3, extra_3;
        const requestPath = API_Machine_Services(pick((service) => service.MachineId, newService.Services));
        return ((body = Auto_generateBoxedEncoder_437914C6(ServiceTicket_$reflection(), undefined, undefined, undefined)(newService), (decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Service_$reflection()), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Service_$reflection()), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })())))))).then((_arg_2) => {
            dispatch(new Message(0, [_arg_2]));
            return Promise.resolve();
        });
    }));
    pr_1.then();
}

function ActivitiesThisMonth(activitiesThisMonthInputProps) {
    let snd, elems_2, elems, elems_1;
    const activities = activitiesThisMonthInputProps.activities;
    const onEdit = activitiesThisMonthInputProps.onEdit;
    const patternInput = reactApi.useState(0);
    const page = patternInput[0] | 0;
    const ctx = reactApi.useContext(ctx_1);
    const count = activities.length | 0;
    const numPages = ~~Math.ceil(count / 2) | 0;
    const rowsToSkip = (page * 2) | 0;
    const rowsToTake = ((count < (rowsToSkip + 2)) ? (count - rowsToSkip) : 2) | 0;
    const currentPageText = MuiHelpers_createElement(Typography, [["children", toText(interpolate("Viser %P()-%i%P() av %d%P() hendelser", [(page * 2) + 1, (snd = (((page * 2) + 2) | 0), (count < snd) ? count : snd), count]))]]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: 100 + "%",
        rowGap: 15 + "px",
    }], (elems_2 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("Services.EventsThisMonth")]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        rowGap: 10 + "px",
    }], (elems = toList(delay(() => ((count === 0) ? singleton(MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", ctx.Locale.t("Services.NoEvents")]])) : singleton(map((activity) => {
        const $key3FA294E7 = activity.Id | 0;
        return createElement(Components_ActivityItem_Z3817E89A, {
            key: $key3FA294E7,
            $key: $key3FA294E7,
            activity: activity,
            onEdit: () => {
                onEdit(activity);
            },
        });
    }, sortBy((_arg_1) => _arg_1.PlannedDate, getSubArray(activities, rowsToSkip, rowsToTake), {
        Compare: comparePrimitives,
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        alignSelf: "flex-end",
        columnGap: 10 + "px",
    }], (elems_1 = toList(delay(() => append_1(!(activities.length === 0) ? singleton(currentPageText) : empty_1(), delay(() => singleton(MuiHelpers_createElement(Pagination, [["page", page + 1], ["count", numPages], ["onChange", (delegateArg, delegateArg_1) => {
        patternInput[1](delegateArg_1 - 1);
    }]])))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function Activities(activitiesInputProps) {
    const target = activitiesInputProps.target;
    const responsive = useResponsive(undefined);
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const arg_1 = init(target);
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(true);
    const setLoading = patternInput_1[1];
    const activitiesThisMonth = model_1.Entries.filter((activity) => {
        const plannedDate = parse(activity.PlannedDate);
        if (year(plannedDate) === year_1(now())) {
            return month(plannedDate) === month_1(now());
        }
        else {
            return false;
        }
    });
    useEffectWithDeps(() => {
        let properties_2;
        let rendering = true;
        const url = Target__RequestPath(target);
        const nowStr = toLongTimeString(now());
        console.debug(`[Activities ${nowStr}] target changed`, target);
        setLoading(true);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Service_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(url, properties_3).then((_arg_1) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Service_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg_2) => (new FSharpResult$2(1, [new FetchError(3, [arg_2])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (rendering) {
                dispatch(new Message(4, [res]));
            }
            else {
                const nowStr_1 = toLongTimeString(now());
                console.warn(some(`[Activities ${nowStr_1}] Fetched while rendering or whatever`));
            }
            setLoading(false);
        });
        return createDisposable(() => {
            rendering = false;
            dispatch(new Message(6, [[]]));
            setLoading(false);
        });
    }, [target]);
    useEffectOnce(() => {
        switch (target.tag) {
            case 1: {
                dispatch(new Message(1, [new FSharpResult$2(0, [target.fields[2]])]));
                break;
            }
            case 2: {
                const pr_3 = Machine_fetchMachineInfo(target.fields[3].Id);
                pr_3.then((res_1) => {
                    if (res_1.tag === 0) {
                        const machineInfo = res_1.fields[0];
                        Customer_fetchCustomerInfo(machineInfo.CustomerId, (arg_7) => {
                            dispatch(new Message(1, [arg_7]));
                        });
                        dispatch(new Message(5, [new FSharpResult$2(0, [machineInfo])]));
                    }
                    else {
                        console.error(some("Could not fetch machine info"), res_1.fields[0]);
                    }
                });
                break;
            }
            default:
                dispatch(new Message(2, [new FSharpResult$2(0, [target.fields[1]])]));
        }
    });
    const xs_3 = toList(delay(() => append_1(singleton(createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(10, []));
        },
    })), delay(() => append_1(model_1.AddForm ? singleton(createElement(CreationDialog, {
        customersOpt: unwrap(Target__ToCustomersOpt(target)),
        machineOpt: unwrap(Target__ToMachineOpt(target)),
        machines: Target__ToMachines(target),
        isOpen: true,
        onClose: (_arg_5) => {
            if (_arg_5 != null) {
                const newService = _arg_5;
                tryCreate(dispatch, new ServiceTicket(undefined, singleton_1(new Service(newService.Id, newService.CreatedById, newService.CreatedBy, newService.Status, newService.ClosingComment, newService.Severity, newService.Type, newService.Description, newService.VismaOrder, (newService.CustomerId >= 0) ? newService.CustomerId : defaultArg(map_1((c) => c.Id, model_1.Customer), -1), newService.Customer, newService.MachineId, newService.MachineName, newService.MachineCode, newService.TicketIdOpt, newService.NotifyInternally, newService.InternalRecipients, newService.NotifyCustomers, newService.CustomerRecipients, newService.PlannedDate, newService.NotifyDate, newService.CompletedDate))));
            }
            else {
                dispatch(new Message(7, [false]));
            }
        },
    })) : empty_1(), delay(() => {
        let matchValue_1, elems_2, elems_1, value_10, elems;
        return append_1((matchValue_1 = responsive, (matchValue_1 === "mobileLandscape") ? singleton(defaultOf()) : ((matchValue_1 === "tablet") ? singleton(defaultOf()) : ((matchValue_1 === "desktop") ? singleton(defaultOf()) : ((matchValue_1 === "wideScreen") ? singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "flex-start",
            columnGap: 30 + "px",
        }], (elems_2 = [createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], (elems_1 = [MuiXHelpers_createElement(LocalizationProvider, [(value_10 = AdapterDateFns, ["dateAdapter", value_10]), (elems = toList(delay(() => ((target.tag === 1) ? singleton(createElement(Components_ActivityCalendar_Z2E686B84, {
            groupId: target.fields[0],
            customerId: target.fields[1],
        })) : ((target.tag === 2) ? singleton(createElement(Components_ActivityCalendar_Z2E686B84, {
            groupId: target.fields[0],
            customerId: target.fields[1],
            machineId: target.fields[2],
        })) : singleton(createElement(Components_ActivityCalendar_Z2E686B84, {
            groupId: target.fields[0],
        })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(ActivitiesThisMonth, {
            onEdit: (arg_8) => {
                dispatch(new Message(8, [arg_8]));
            },
            activities: activitiesThisMonth,
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : singleton(defaultOf()))))), delay(() => {
            let elems_3;
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                rowGap: 15 + "px",
            }], (elems_3 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("Services.AllPlannedActivities")]]), createElement(Table, {
                target: target,
                loading: patternInput_1[0],
                services: model_1.Entries,
                addCallback: () => {
                    dispatch(new Message(7, [true]));
                },
                deleteCallback: (arg_9) => {
                    dispatch(new Message(3, [arg_9]));
                },
                updateCallback: (arg_10) => {
                    dispatch(new Message(8, [arg_10]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
        }));
    }))))));
    return react.createElement(react.Fragment, {}, ...xs_3);
}

